import { Component, Input, forwardRef, Output, EventEmitter, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { bbDeepCopy } from '../../../shared/utils/bbDeepCopy.util';

@Component({
	selector: 'bb-object-editor',
	templateUrl: './bb-object-editor.component.html',
	styleUrls: ['./bb-object-editor.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbObjectEditorComponent),
		multi: true
	}]
})

export class BbObjectEditorComponent implements ControlValueAccessor, OnInit {
	@Input() pickerPosition = 'bottom';
	@Input() parent: any;
	@Output() duplicateRequest: EventEmitter<any> = new EventEmitter<any>();
	modelValue: any;

	formControl: UntypedFormControl;
	keyValuePairs: any[] = [];
	expanded: any = {};
	newObjects: any = {};

	constructor(

	) {
		this.formControl = new UntypedFormControl();
	}

	ngOnInit() {

	}

	duplicate(kvp: any, parentKvp: any) {
		this.duplicateRequest.emit(kvp);
	}

	onDuplicateRequest(kvpToCopy: any, intoKvp: any) {
		if (kvpToCopy && intoKvp.key && this.modelValue[intoKvp.key] && this.modelValue[intoKvp.key].length) {
			this.modelValue[intoKvp.key].push(bbDeepCopy(kvpToCopy.value));
			this.propagateChange(this.modelValue);
			this.updateKeyValuePairs();
		}
	}

	onValueChange(val: any, keyValuePair: any) {
		this.modelValue[keyValuePair.key] = val;
		this.propagateChange(this.modelValue);
	}

	addChild(keyValuePair: any, value: any, newKey?: string) {
		let parsedValue = null;
		try {
			parsedValue = JSON.parse(value);
		} catch (e) {
			parsedValue = value;
		}
		if (keyValuePair) {
			if (keyValuePair.type === 'object') {
				if (keyValuePair.isArray) {
					keyValuePair.value.push(parsedValue);
				} else {
					if (newKey) {
						keyValuePair.value[newKey] = value;
					}
				}
				this.updateKeyValuePairs();
				this.propagateChange(this.modelValue);
			}
		}
	}

	remove(keyValuePair: any) {
		delete this.modelValue[keyValuePair.key];
		this.updateKeyValuePairs();
		this.propagateChange(this.modelValue);
	}

	updateKeyValuePairs() {
		if (this.modelValue) {
			this.keyValuePairs = Object.keys(this.modelValue).map((key) => {
				const val = this.modelValue[key];
				return {
					key,
					type: typeof val,
					numChilds: val.length ? val.length : Object.keys(val).length,
					isArray: typeof val === 'object' && typeof val.length === 'number',
					value: val
				};
			});
		}
	}

	// ControlValueAccessor fields:
	writeValue(value: any) {
		this.modelValue = value;
		this.updateKeyValuePairs();
	}

	propagateChange = (_: any) => { };

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
